<template>
  <base-page-layout title="Produtos impulsionadores">
    <step1-sales-strategy />
  </base-page-layout>
</template>

<script>
import { DateTime } from 'luxon'
import { mapState } from 'vuex'
import { produtosImpulsionadores } from '../../mixins/produtos-impulsionadores'
import Step1SalesStrategy from './Step1SalesStrategy.vue'
export default {
  name: 'WantSell',
  components: {
    BasePageLayout: () => import('@/components/BasePageLayout.vue'),
    Step1SalesStrategy,
  },
  mixins: [produtosImpulsionadores],
  data: () => ({}),
  computed: {
    ...mapState({
      lastUpdate: (state) => state.lastUpdate,
    }),
    firstDayOfLastMonth() {
      if (!this.lastUpdate.last_updated) return ''
      return DateTime.fromFormat(this.lastUpdate.last_updated.toString(), 'yyyyMMdd').plus({ months: -1 }).startOf('month').toFormat('yyyy-MM-dd')
    },
    firstDayReferencyMonth() {
      if (!this.lastUpdate.last_updated) return ''
      return DateTime.fromFormat(this.lastUpdate.last_updated.toString(), 'yyyyMMdd').plus({ months: -1 }).toFormat('yyyy-MM-dd')
    },
    firstDayOfCurrentMonth() {
      if (!this.lastUpdate.last_updated) return ''
      return DateTime.fromFormat(this.lastUpdate.last_updated.toString(), 'yyyyMMdd').startOf('month').toFormat('yyyy-MM-dd')
    },
    lastDay() {
      if (this.lastUpdate.last_updated) return DateTime.fromFormat(this.lastUpdate.last_updated.toString(), 'yyyyMMdd').toFormat('yyyy-MM-dd')
      return ''
    },
  },
  watch: {
    'lastUpdate.last_updated': {
      handler() {
        const filters = this.opportunities.filters
        const newFilters = {
          products: filters.products,
          units: filters.units,
          referenceDate: [this.firstDayOfLastMonth, this.firstDayReferencyMonth],
          currentDate: [this.firstDayOfCurrentMonth, this.lastDay],
        }
        this.SET_OPPORTUNITIES_KEY({ key: 'filters', payload: newFilters })
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped></style>
